const $priceInput = $("#calc-flat-price");
const $priceInputShadow = $("#calc-flat-price-num");
const $priceSlider = $("#calc-flat-price-slider");
const $priceOrder = $("#calc-order-price");

const $payInput = $("#calc-first-pay");
const $payInputShadow = $("#calc-first-pay-num");
const $paySlider = $("#calc-first-pay-slider");
const $payPercent = $("#calc-first-pay-percent");
const $payOrder = $("#calc-order-first-pay");

const $amountInput = $("#calc-credit-amount");
const $amountSlider = $("#calc-credit-amount-slider");
const $amountOrder = $("#calc-order-credit-amount");

const $periodInput = $("#calc-credit-period");
const $periodSlider = $("#calc-credit-period-slider");
const $periodOrder = $("#calc-order-credit-period");

const $ageInput = $("#calc-user-age");
const $ageSlider = $("#calc-user-age-slider");
const $ageOrder = $("#calc-order-user-age");
const myRoud = 100000;

function amount2Word(amount, words) {
  var resOfHundred = amount % 100;
  var restOfTen = amount % 10;
  var resultString;

  switch (true) {
    case resOfHundred >= 5 && resOfHundred <= 20:
      resultString = " " + words[2];

      break;

    default:
      switch (true) {
        case restOfTen == 1:
          resultString = " " + words[0];

          break;
        case restOfTen >= 2 && restOfTen <= 4:
          resultString = " " + words[1];

          break;
        default:
          resultString = " " + words[2];

          break;
      }
      break;
  }
  return resultString;
}

function PrintElem($elem) {
  var mywindow = window.open("", "PrintWindow");

  mywindow.document.write("<html><head><title>" + document.title + "</title>");
  mywindow.document.write(
    `<style>
      @page {
        size: A4;
        margin: 2mm;
      }

      body, html {
        padding: 0;
      }

      p {
        margin-bottom: 40px;
        text-align: center;
      }

      .calculator-print {
        display: none;
        padding: 0;
        margin: 0;
      }

      .calculator-print__header {
        display: table;
        background: #ededed;
        padding: 20px;
        border: solid 1px #eeeeee;
        margin-bottom: 40px;
        width: 100%;
      }

      .calculator-print__item {
        display: table-cell;
        text-align: center;
        background: #ededed;
        padding: 0;
      }

      .calculator-print__img {
        display: block;
        width: 150px;
        margin: 0 auto 50px;
      }

      .calculator-print__body {
        width: 100%;
        padding: 0 20px;
      }

      .calculator-print__body td,
      .calculator-print__body th {
        text-align: left;
        padding: 10px 0;
        border-bottom: solid 1px #eeeeee;
      }
    </style>`
  );
  mywindow.document.write("</head><body>");
  mywindow.document.write($elem.html());
  mywindow.document.write("</body></html>");

  mywindow.document.close();
  mywindow.focus();

  mywindow.print();
  mywindow.close();

  return true;
}

function emailElem(innerHtml) {
  var template =
    `<html>
    <head>
      <style>
        body, html {
          padding: 0;
        }

        p {
          margin-bottom: 40px;
          text-align: center;
        }

        .calculator-print {
          display: none;
          padding: 0;
          margin: 0;
        }

        .calculator-print__header {
          display: table;
          background: #ededed;
          padding: 20px;
          border: solid 1px #eeeeee;
          margin-bottom: 40px;
          width: 90%;
        }

        .calculator-print__item {
          display: table-cell;
          text-align: center;
          background: #ededed;
          padding: 0;
        }

        .calculator-print__img {
          display: block;
          width: 150px;
          margin: 0 auto 50px;
        }

        .calculator-print__body {
          width: 95%;
          padding: 0 20px;
        }

        .calculator-print__body td,
        .calculator-print__body th {
          text-align: left;
          padding: 10px 0;
          border-bottom: solid 1px #eeeeee;
        }
      </style>
    </head>
    <body>` +
    innerHtml +
    `</body>
  </html>`;

  return template;
}

class Calculator {
  constructor() {
    let $params = $("[data-calculator-params]");
    let $submit = $("[data-calculator-submit]");
    let $print = $("[data-calculator-print]");
    let $showMore = $("[data-show-more]");
    let $form = $("[data-calc-form], [data-calculator-email]");
    let $email = $("[data-calculator-email]");

    this.paramsInit($params);
    this.calculate($submit, $print, $showMore);
    this.print($print);
    this.showMore($showMore);
    this.formValidateInit($form);
    this.emailFormInPopup($email);

    if ($(".TurnScreenModal").length && $("#cacl-page").length) {
      $(".TurnScreenModal").hide();
    }
  }

  emailFormInPopup($emailForm) {
    let $wrapper = $emailForm.closest(".calculator-email");
    let title = "Отправить на почту";
    let text = "Введите ваш e-mail, и мы отправим вам расчет ипотеки";
    let $link = $("[data-fancybox=calculator-email]");

    $link.on("click", function () {
      $wrapper.find(".calculator-email__tlt").text(title);
      $wrapper.find("p").text(text);
      $emailForm.show();
    });
  }

  ajaxSendFormPopup(event) {
    event.preventDefault();

    let $this = $(this);
    let $wrapper = $this.closest(".calculator-email");
    let url = $this.attr("action");
    let method = $this.attr("method");
    let calcData = $("[data-calculator-print]").html();
    let data = emailElem(calcData);
    let sendData = $this.serialize() + "&text=" + data.replace(/&nbsp;/g, " ");

    $.ajax({
      url: url,
      method: method,
      data: sendData,
      success: function (response) {
        $.fancybox.close();
        $("#calculator-form").find(".Modal_title").text(response.title);
        $("#calculator-form").find("p").text(response.text);
        $.fancybox.open({
          src: "#calculator-form",
        });
      },
    });
  }

  ajaxSendFrom(event) {
    event.preventDefault();

    let $this = $(this);
    let $button = $this.find('[type="submit"]');
    let curHeight = $this.outerHeight();
    let data = $this.serialize();
    let url = $this.attr("action");
    let method = $this.attr("method");
    const urlCaptcha = $this.data("url-captcha");

    this.validator.destroy();

    $.ajax({
      url: url,
      method: method,
      data: data,
      success: (response) => {
        console.log("success", response);
        if (response.code === 0) {
          this.reset();

          $($button.attr("href") + " p").text(response.success);

          $.fancybox.open({
            src: $button.attr("href"),
          });

          $.ajax({
            url: "https://dom-rafinad.ru/ajax/get_captcha.json",
            success: function (resp) {
              const captchaHash = resp.captcha_password;
              const $captchaInp = $('input[name="captcha_code"]');
              $captchaInp.val(captchaHash);
              const $imgCaptcha = $this.find("img");
              $imgCaptcha.attr(
                "src",
                `/bitrix/tools/captcha.php?captcha_code=${captchaHash}`
              );
            },
          });
        }

        if (response.code === 100) {
          const $captchaInp = $this.find(".js-captcha ");
          const $tooltip = $captchaInp.parent().find(".ui-tooltip");
          const $tooltipContent = $tooltip.find(".ui-tooltip-content");
          $tooltipContent.html(`<strong>Неверный код с картинки</strong>`);
          $tooltip.show();
        }

        $("body").trigger("validate");
      },
    });
  }

  getPositionTooltip($elem, $tooltip, id) {
    let left = 0;
    let top = 0;

    if ($tooltip.length) {
      left = $elem.width() / 2 - $tooltip.width() / 2;

      if (id == "calc-details-email") {
        top =
          parseInt($elem.css("margin-bottom")) +
          $elem.height() / 2 +
          parseInt($elem.css("margin-top")) / 2 -
          3;
      } else {
        top = $elem.parent().outerHeight() - 6;
      }
    }

    return {
      left: left,
      top: top,
    };
  }

  getFirstUnValidElem(validator) {
    let self = this;
    return new Promise(function (resolve) {
      let $el = $(validator.currentForm)
        .find("input[required]")
        .filter(function () {
          return !validator.element($(this));
        })
        .first();

      self.isHilith = false;
      resolve($el);
    });
  }

  formValidateInit($form) {
    let self = this;

    var validSettings = {
      highlight: function (element, errorClass, validClass) {
        // Add Error
        let $el = $(element);
        $el.addClass(errorClass);
        $el.removeClass(validClass);

        if (!self.isHilith) {
          self.isHilith = true;
          self.getFirstUnValidElem(this).then(function ($firstFind) {
            let id = $firstFind.attr("name");
            let $tooltip = $("#" + id);
            let $tooltips = $(".ui-tooltip");
            let offset = self.getPositionTooltip($firstFind, $tooltip, id);

            $tooltips.hide();
            $tooltip.show();
            $tooltip.css(offset);
          });
        }
      },
      unhighlight: function (element, errorClass, validClass) {
        // Remove Error
        let $el = $(element);
        $el.removeClass(errorClass);
        $el.addClass(validClass);

        if (!self.isHilith) {
          self.isHilith = true;
          self.getFirstUnValidElem(this).then(function ($firstFind) {
            let id = $firstFind.attr("name");
            let $tooltip = $("#" + id);
            let $tooltips = $(".ui-tooltip");
            let offset = self.getPositionTooltip($firstFind, $tooltip, id);

            $tooltips.hide();
            $tooltip.show();
            $tooltip.css(offset);
          });
        }
      },
      ignore: ":hidden, input.js-ignore",
      errorElement: "span",
      errorPlacement: function (error, element) {
        // console.log(error, element)
        return true;
      },
      submitHandler: function (form, event) {
        if (!!$(form).attr("data-calculator-email")) {
          self.ajaxSendFormPopup.call(form, event);
        } else {
          if (form.validator.numberOfInvalids() == 0) {
            self.ajaxSendFrom.call(form, event);
          }
        }
      },
    };

    $.validator.addMethod("email", function (value, element) {
      var rexp =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var rexp2 = /[a-zA-Z]/;
      var result = rexp.test(value) && rexp2.test(value.split("@")[0]);

      return this.optional(element) || result;
    });

    $.validator.addMethod("tel", function (value, element) {
      var rexp =
        /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/;
      return this.optional(element) || rexp.test(value);
    });

    // Роли для полей
    $.validator.addClassRules({
      "js-email": {
        email: true,
      },
      "js-phone": {
        tel: true,
      },
    });

    $("body").on("validate", function () {
      $form.each(function () {
        this.validator = $(this).validate(validSettings);
      });
    });

    $("body").trigger("validate");
  }

  showMore($showMore) {
    var $result = $(".calculator-result");

    $showMore.on("click", function (e) {
      let $this = $(this);
      let active = "_active";
      let numberOfItemsShown = 5;
      let height =
        $(".calculator-result__item").outerHeight() * numberOfItemsShown;

      if ($this.hasClass(active)) {
        $this.removeClass(active).text("Показать больше банков");

        $result.stop().animate({
          height: height,
        });

        return;
      }

      $this.addClass(active).text("Скрыть");

      $result.stop().animate({
        height: $(".calculator-result__inner").get(0).scrollHeight,
      });
    });
  }

  print($print) {
    let $printBtn = $("[data-calculator-print-btn]");

    $printBtn.on("click", function (e) {
      e.preventDefault();

      let $print = $("[data-calculator-print]");

      PrintElem($print);
    });
  }

  paramsInit($params) {
    let $items = $params.find("[data-params-item]");

    $items.each((i, e) => {
      let $item = $(e);
      let $slider = $item.find("[data-params-slider]");
      let $input = $item.find("[data-params-input]");
      let data = $slider.data("params-slider");

      this.sliderInit($item, $slider, data);
    });
  }

  inputInit($wrapper, $input, data) {
    var $slider = $wrapper.find("[data-params-slider]");
    var dataMin = data.min;
    var dataMax = data.max;

    //чехарда с инпутами начало
    $priceInput.on("click", function () {
      $priceInput.hide();
      $priceInputShadow
        .val($priceInput.val().replace(/\D/g, ""))
        .show()
        .focus();
    });

    $priceInputShadow.on("blur", function () {
      $priceInput.val($priceInputShadow.val()).show().blur();
      $priceInputShadow.hide();
    });

    $priceInputShadow.on("keydown", function (e) {
      if (
        $.inArray(e.keyCode, [9, 27, 13, 110, 190]) !== -1 ||
        0
        //(e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        //(e.keyCode >= 35 && e.keyCode <= 40)
      ) {
        $(this).blur();

        return;
      }
    });

    //#2
    $payInput.on("click", function () {
      $payInput.hide();
      $payInputShadow.val($payInput.val().replace(/\D/g, "")).show().focus();
    });

    $payInputShadow.on("blur", function () {
      $payInput.val($payInputShadow.val()).show().blur();
      $payInputShadow.hide();
    });

    $payInputShadow.on("keydown", function (e) {
      if (
        $.inArray(e.keyCode, [9, 27, 13, 110, 190]) !== -1 ||
        0
        //(e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        //(e.keyCode >= 35 && e.keyCode <= 40)
      ) {
        $(this).blur();

        return;
      }
    });
    // чехарда с инпутами конец

    $input.on("focus", function (e) {
      let $this = $(this);
      let value = $this.val().replace(/\D/g, "");
      $this.val(value);
    });

    $input.on("keydown", function (e) {
      if (
        $.inArray(e.keyCode, [9, 27, 13, 110, 190]) !== -1 ||
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        (e.keyCode >= 35 && e.keyCode <= 40)
      ) {
        $(this).blur();

        return;
      }

      if (
        $.inArray(e.keyCode, [46, 8]) === -1 &&
        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        e.preventDefault();

        return;
      }
    });

    $input.on("keyup", function (e) {
      let $this = $(this);
      let value = $this.val().replace(/\D/g, "");

      $slider.slider("option", "value", value);
    });

    $input.on("blur", function () {
      let $this = $(this);
      let value = $this.val();
      if ($this.is("#calc-first-pay")) {
        dataMin = Math.round($priceInput.data("val") * 0.1);
        dataMax = Math.round($priceInput.data("val") * 0.85);
        $paySlider.slider("option", "value", value);
      }

      if (value < dataMin) {
        value = dataMin;
      } else if (value > dataMax) {
        value = dataMax;
      }

      if ($this.is("#calc-flat-price")) {
        $paySlider.slider(
          "option",
          "min",
          Math.round((value * 0.1) / myRoud) * myRoud
        );
        $paySlider.slider(
          "option",
          "max",
          Math.round((value * 0.85) / myRoud) * myRoud
        );
        $priceSlider.slider("option", "value", value);
      }

      $this
        .val(Number(value).toLocaleString("ru-RU") + " ₽")
        .data("val", value);

      let procent = (
        ($payInput.data("val") / $priceInput.data("val")) *
        100
      ).toFixed(0);
      $payPercent.val(procent + "%");

      let amount = $priceInput.data("val") - $payInput.data("val");

      if (amount < 0) {
        amount = 0;
      }
      //$payInput.slider('option', 'value', amount);

      let resultValSlideDot =
        ((100 - procent) * $amountSlider.slider("option", "max")) / 100;
      $amountInput.val(Number(amount).toLocaleString("ru-RU") + " ₽");
      $amountSlider.slider("option", "value", resultValSlideDot);
      // $amountSlider.slider("option", "max", amount);

      $amountOrder.val(amount).data("val", amount);
    });

    $('[name="calc-order-phone"]').inputmask({
      mask: "+7 999 999-99-99",
      showMaskOnHover: false,
    });
  }

  sliderInit($wrapper, $slider, data) {
    let disabled = data.disabled;
    let min = data.min;
    let max = data.max;
    let step = data.step;
    let val = data.val;
    let type = data.type;
    let amountVal = null;

    if (type === "amount") {
      amountVal = (max * parseInt($("#calc-first-pay-percent").val())) / 100;
    }

    let $input = $wrapper.find("[data-params-input]");
    let ageWord = amount2Word(val, ["год", "года", "лет"]);

    let rouble =
      type === "price" || type === "payment" || type === "amount"
        ? " ₽"
        : " " + ageWord;

    $input.val(Number(val).toLocaleString("ru-RU") + rouble).data("val", val);

    $priceOrder.val($priceInput.data("val"));
    $payOrder.val($payInput.data("val"));
    $amountOrder.val($amountInput.data("val"));
    $periodOrder.val($periodInput.data("val"));
    $ageOrder.val($ageInput.data("val"));

    $payPercent.val(
      ($payInput.data("val") / $priceInput.data("val")) * 100 + "%"
    );

    $slider.slider({
      create: function (event, ui) {
        let $cont = $(this);
        let $first = $cont.children().first();
        let $last = $cont.children().last();
        $first.before($last);
      },
      min: min,
      max: max,
      disabled: disabled,
      step: step,
      value: !!amountVal ? amountVal : val,
      classes: {
        "ui-slider": "calculator-slider",
        "ui-slider-handle": "calculator-slider__handle",
        "ui-slider-range": "calculator-slider__range",
      },
      range: "min",
      slide: function (e, ui) {
        let curValue = ui.value;

        ageWord = amount2Word(curValue, ["год", "года", "лет"]);

        $input
          .val(Number(curValue).toLocaleString("ru-RU") + rouble)
          .data("val", curValue);

        if (type === "price") {
          if (curValue * 0.85 < $paySlider.slider("option", "value")) {
            $paySlider.slider(
              "option",
              "value",
              Math.round((curValue * 0.85) / myRoud) * myRoud
            );
            $payInput
              .val(Math.round(curValue * 0.85).toLocaleString("ru-RU") + rouble)
              .data("val", curValue * 0.85);
          }

          $paySlider.slider(
            "option",
            "max",
            Math.round((curValue * 0.85) / myRoud) * myRoud
          );
          $paySlider.slider(
            "option",
            "min",
            Math.round((curValue * 0.1) / myRoud) * myRoud
          );
          $priceOrder
            .val($priceInput.data("val"))
            .data("val", Math.round(curValue * 0.85));

          if (curValue * 0.1 > $payInput.data("val")) {
            $paySlider.slider(
              "option",
              "value",
              Math.round((curValue * 0.1) / myRoud) * myRoud
            );
            $payInput
              .val(Math.round(curValue * 0.1).toLocaleString("ru-RU") + rouble)
              .data("val", Math.round(curValue * 0.1));
          }
        }

        if (type === "payment") {
          $payOrder.val($payInput.data("val"));
        }

        if (type === "price" || type === "payment") {
          let amount = $priceInput.data("val") - $payInput.data("val");

          if (amount < 0) {
            amount = 0;
          }

          let procent = Math.round(
            ($payInput.data("val") / $priceInput.data("val")) * 100
          );
          $payPercent.val(procent + "%");

          $amountInput
            .val(Number(amount).toLocaleString("ru-RU") + rouble)
            .data("val", amount);

          let resultValSlideDot =
            ((100 - procent) * $amountSlider.slider("option", "max")) / 100;
          $amountSlider.slider("option", "value", resultValSlideDot);
          // $amountSlider.slider('option', 'max', amount);

          $amountOrder.val(amount);
        }

        if (type === "period") {
          $periodInput
            .val(Number(curValue).toLocaleString("ru-RU") + (" " + ageWord))
            .data("val", curValue);

          $periodOrder.val($periodInput.data("val"));
        } else if (type === "age") {
          $ageInput
            .val(Number(curValue).toLocaleString("ru-RU") + (" " + ageWord))
            .data("val", curValue);

          $ageOrder.val($ageInput.data("val"));
        }
      },
    });

    if (!$input[0].hasAttribute("readonly")) {
      this.inputInit($wrapper, $input, data);
    }
  }

  errorMessage(isShow = false) {
    let $errorTemplate = $("[data-calc-error-msg]");
    let $result = $("[data-calc-result-item]");

    $errorTemplate.attr("style", "");
    $result.attr("style", "");

    if (isShow) {
      $errorTemplate.show();
      $result.hide();
    } else {
      $errorTemplate.hide();
      $result.show();
    }
  }

  calculate($submit, $print, $showMore) {
    let self = this;
    $submit.on("click", function (e) {
      var sTop = $submit.offset().top;
      $("html, body")
        .stop()
        .animate({
          scrollTop: "+" + sTop,
        });

      e.preventDefault();

      var housingComplexId = "648";
      var agendaType = "primary_housing";
      var isMilitaryGrade = "regular";
      var MortgageType = "STANDARD";
      var isInsured = "true";
      var proofOfIncome = "ndfl";
      var isRfCitizen = "true";
      var cost = $priceInput.data("val") * 100;
      var initialPayment = $payInput.data("val") * 100;
      var age = $ageInput.data("val");
      var credit_time = $periodInput.data("val") * 12;

      var url =
        "https://gql.ipoteka.digital/gql?query={getLoanOffer(housingComplexId:" +
        housingComplexId +
        "agendaType:" +
        agendaType +
        ",cost:" +
        cost +
        ",initialPayment:" +
        initialPayment +
        ",mortgageType:" +
        MortgageType +
        ",isInsured:" +
        isInsured +
        ",proofOfIncome:" +
        proofOfIncome +
        ",isRfCitizen:" +
        isRfCitizen +
        ",age:" +
        age +
        "){id,bankName,bankLogo,periods{period,amount},recommendedIncomeCoeff,rate}}";
      var GovermentTypeUrl =
        "https://gql.ipoteka.digital/gql?query={getLoanOffer(housingComplexId:" +
        housingComplexId +
        "agendaType:" +
        agendaType +
        ",cost:" +
        cost +
        ",initialPayment:" +
        initialPayment +
        ",mortgageType:" +
        "GOVERNMENT_SUPPORT" +
        ",isInsured:" +
        isInsured +
        ",proofOfIncome:" +
        proofOfIncome +
        ",isRfCitizen:" +
        isRfCitizen +
        ",age:" +
        age +
        "){id,bankName,bankLogo,periods{period,amount},recommendedIncomeCoeff,rate}}";
      let $result = $("[data-calc-result]");
      let active = "_active";

      $result
        .removeClass("_empty _short")
        .find(".calculator-result__inner")
        .empty();
      $result.addClass(active).find(".Preloader_pic").show();
      $("[data-calc-show]").addClass(active);

      let $printHeader = $print.find(".calculator-print__header");
      let $printBody = $print.find(".calculator-print__tbody");

      $printBody.empty();
      $printHeader.empty().append(
        `<div class="calculator-print__item">` +
          $priceInput.data("val").toLocaleString("ru-RU") +
          ` руб.<br>Стоимость недвижимости</div>
          <div class="calculator-print__item">` +
          $payInput.data("val").toLocaleString("ru-RU") +
          ` руб.<br>Первоначальный взнос</div>
          <div class="calculator-print__item">` +
          $amountInput.data("val").toLocaleString("ru-RU") +
          ` руб.<br>Сумма кредита</div>
          <div class="calculator-print__item">` +
          $periodInput.data("val") +
          amount2Word($periodInput.data("val"), ["год", "года", "лет"]) +
          `<br>Срок ипотеки</div>
          <div class="calculator-print__item">` +
          $ageInput.data("val") +
          amount2Word($ageInput.data("val"), ["год", "года", "лет"]) +
          `<br>Возраст заемщика</div>
        `
      );

      var goverment_banks_json;

      $.getJSON(GovermentTypeUrl, function (data) {
        goverment_banks_json = data;
      }).done(function () {
        $.getJSON(url, function (data) {
          $showMore.removeClass(active).text("Показать больше банков");
          var banks_json = data;

          function GetSortOrder(prop) {
            return function (a, b) {
              if (a[prop] > b[prop]) {
                return 1;
              } else if (a[prop] < b[prop]) {
                return -1;
              }

              return 0;
            };
          }

          let getTextAfterResize = (array) => {
            let width = window.innerWidth;
            let [mobile, tablet, desktop] = array;

            if (width >= 320 && width < 768) {
              return mobile;
            } else if (width >= 768 && width < 1280) {
              return tablet;
            } else if (width >= 1280) {
              return desktop;
            }
          };

          var banks_arr = banks_json.data.getLoanOffer.concat(
            goverment_banks_json.data.getLoanOffer
          );

          banks_arr = banks_arr.sort(GetSortOrder("rate"));

          const banksMap = new Map();
          let uniqBanks = [];

          banks_arr.map((bank) => {
            const key = `${bank.bankName}/${bank.rate}`;
            if (!banksMap.has(key)) {
              banksMap.set(key, bank);
            }
          });

          banksMap.forEach(function (bank) {
            uniqBanks.push(bank);
          });

          banks_arr = uniqBanks;

          banks_arr.forEach(function (element) {
            var bank_name = element.bankName;
            var bank_rate = element.rate;
            var bank_periods = element.periods;
            var bank_month_amount = 0;
            var bank_logo = element.bankLogo;

            bank_periods.forEach(function (bank_period) {
              var period_months = bank_period.period;
              var period_amount = Math.ceil(
                bank_period.amount / 100
              ).toLocaleString("ru-RU");
              var period =
                period_months / 12 +
                amount2Word(period_months / 12, ["год", "года", "лет"]);
              var template =
                `<div class="calculator-result__item calculator-result-item">
                    <div class="calculator-result-item__td" title="${bank_name}">
                      <img class="calculator-result-item__img" src="` +
                bank_logo +
                `" alt="">
                    </div>
                    <div class="calculator-result-item__td">
                      <div class="calculator-result-item__val">` +
                period +
                `</div>
                      <div class="calculator-result-item__key">Срок до</div>
                    </div>
                    <div class="calculator-result-item__td">
                      <div class="calculator-result-item__val">` +
                bank_rate +
                `%</div>
                      <div class="calculator-result-item__key">` +
                getTextAfterResize(["Ставка", "Ставка", "Ставка от"]) +
                `</div>
                    </div>
                    <div class="calculator-result-item__td">
                      <div class="calculator-result-item__val">` +
                period_amount +
                ` ₽</div>
                      <div class="calculator-result-item__key">` +
                getTextAfterResize([
                  "Платеж/мес.",
                  "Платеж/мес.",
                  "Платеж в месяц от",
                ]) +
                `</div>
                    </div>
                    <div class="calculator-result-item__td">
                      <div class="calculator-result-item__val">10%</div>
                      <div class="calculator-result-item__key">` +
                getTextAfterResize([
                  "Первый взнос",
                  "Первый взнос",
                  "Первый взнос от",
                ]) +
                `</div>
                    </div>
                  </div>`;

              var printTplInner =
                `<tr>
                                  <td>` +
                bank_name +
                `</td>
                                  <td>` +
                bank_rate +
                `&nbsp;%</td>
                                  <td>` +
                period +
                `</td>
                                  <td>` +
                period_amount +
                `&nbsp;руб.</td>
                                </tr>`;

              if (credit_time == period_months) {
                $result.find(".calculator-result__inner").append(template);
                $printBody.append(printTplInner);
              }
            });
          });

          $result.find(".Preloader_pic").hide();

          let calcItems = $(".calculator-result-item").length;
          let $container = $(".calculator-result-item").parents(
            "[data-calc-result-item]"
          );
          let height =
            $(".calculator-result-item").first().outerHeight() * calcItems;

          if (calcItems < 5) {
            $result.addClass("_short");
            $(".calculator-result__item.calculator-result-item:last").addClass(
              "calculator-result-item__no-border"
            );
          }

          if (calcItems == 0) {
            self.errorMessage(true);
          } else {
            self.errorMessage(false);

            if (calcItems <= 5) {
              $container.css("height", height);
              $showMore.css("display", "none");
            } else {
              $showMore.css("display", "flex");
            }
          }
        });
      });
    });
  }
}

new Calculator();

$(document.querySelector(".BankList_showMore")).on("click", (event) => {
  event.preventDefault();
  window.requestAnimationFrame(() => {
    $(".BankList_tblBody").toggleClass("BankList_tblBody-closed");
    $(event.currentTarget).toggleClass("showed");
  });
});

/*высота четвертого бокового блока на мобилке*/
var ordeHeight = function () {
  //переменная возвращает высоту заданого элемента
  return $(".Order_part:last-child").outerHeight();
};

if (window.matchMedia("(max-width: 767px)").matches) {
  // присваиваем только на мобилке
  $(".Teaser:nth-of-type(4) .AsideInfo").outerHeight(ordeHeight);
}

$(window).resize(function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $(".Teaser:nth-of-type(4) .AsideInfo").outerHeight(ordeHeight);
  } else {
    $(".Teaser:nth-of-type(4) .AsideInfo").outerHeight("auto");
  }
});

//Пермутентим третий боковой блок на мобилке
var $movable = $(".js-movable");
var $movingPoint = $(".js-movingPoint");
var $initialPoint = $(".js-initialPoint");

if ($movable.length > 0) {
  var moveBlock = function () {
    if (window.matchMedia("(max-width: 767px)").matches) {
      $movingPoint.after($movable); //$movable идет после $movingPoint
    } else {
      $initialPoint.append($movable); //$movable суется внутрь $initialPoint
    }
  };
  moveBlock();

  $(window).resize(function () {
    if ($movable.length > 0) {
      moveBlock();
    }
  });
}

//Пермутентим первый боковой блок на десктопе
var $deskMovable = $(".js-desktop-movable");
var $deskInitialPoint = $(".js-deskInitialPoint");

if ($deskMovable.length > 0) {
  var deskMoveBlock = function () {
    if (window.matchMedia("(min-width: 1280px)").matches) {
      $movingPoint.before($deskMovable);
    } else {
      $deskInitialPoint.append($deskMovable);
    }
  };
  deskMoveBlock();

  $(window).resize(function () {
    if ($deskMovable.length > 0) {
      deskMoveBlock();
    }
  });
}

//ширина блока необходимых документов на десктопе

var blockWidth = function () {
  //переменная возвращает ширину заданого элемента
  return $(".calculator-params__item--mortgage-calc").outerWidth() - 2;
};

if (window.matchMedia("(min-width: 1279px)").matches) {
  // присваиваем только на десктопк
  $(".Order_part:last-child").css({
    minWidth: blockWidth,
    maxWidth: blockWidth,
  });
}

$(window).resize(function () {
  if (window.matchMedia("(min-width: 1279px)").matches) {
    // присваиваем только на десктопк
    $(".Order_part:last-child").css({
      minWidth: blockWidth,
      maxWidth: blockWidth,
    });
  }
});

//фикс суммы кредита
$(document).ready(() => {
  let payment = $("[data-params-slider]").filter(
    (i, e) => $(e).data("params-slider").type === "payment"
  );
  payment = $(payment).data("params-slider").val;

  $("[data-params-slider]").each(function () {
    const params = $(this).data("params-slider");
    const val = params.val;
    if (params.type === "amount") {
      $(this).slider("value", val);
      $(this).slider("option", "max", val + payment);
    }
  });
});
